import { useEffect, useId, useState } from 'react';
import { frameTimecode, parseFrameTimecode } from '../../domain/frame-timecode';

export function TimelineTimecode({ label, frame, first = 0, last, onChange, onInvalid, constraint }: {
  label: string; frame: number; first?: number; last: number; onChange: (frame: number) => void; onInvalid?: (invalid: boolean) => void; constraint?: string;
}) {
  const [text, setText] = useState(frameTimecode(frame));
  const [error, setError] = useState(false);
  const errorId = useId();
  useEffect(() => { setText(frameTimecode(frame)); setError(false); onInvalid?.(false); }, [frame, first, last]);
  const restore = () => { setText(frameTimecode(frame)); setError(false); onInvalid?.(false); };
  const commit = () => {
    const value = parseFrameTimecode(text);
    const invalid = value === null || value < first || value > last;
    setError(invalid); onInvalid?.(invalid);
    if (!invalid && value !== frame) onChange(value!);
  };
  return <label className="timeline-timecode">{label}<input aria-label={label} value={text} spellCheck={false}
    aria-invalid={error} aria-describedby={error ? errorId : undefined} onChange={event => {
      const value = event.target.value; setText(value);
      const parsed = parseFrameTimecode(value); const invalid = parsed === null || parsed < first || parsed > last;
      setError(invalid); onInvalid?.(invalid);
    }} onBlur={commit} onKeyDown={event => {
      if (event.key === 'Enter') { event.preventDefault(); commit(); }
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); restore(); }
    }} />{error && <span id={errorId} role="alert">{parseFrameTimecode(text) === null ? 'Use HH:MM:SS:FF (00–29 frames).'
      : constraint ?? 'Choose a timecode within the film.'}</span>}</label>;
}
